/**
 * The info page's feature-purchase tokens: each offer's cost multiplier, from the initial settings so the page states
 * what the player is charged.
 *   bonus buys (`featurePriceMultipliersById`):
 *     `{feature.super_bonus_buy.multiplier}`     → e.g. "500"
 *     `{feature.vs_rush_buy.multiplier}`         → e.g. "200"
 *   per-spin modes (`featureModeMultipliersById`):
 *     `{feature.bonus_hunt.multiplier}`          → e.g. "2" (the template's name, not the mode's id)
 *     `{feature.guaranteed_vs_mode.multiplier}`  → e.g. "3"
 *
 * Only an offer with a positive multiplier produces a token. An offer the operator disabled (missing or ≤ 0) has none,
 * and its `<li data-feature="<offer id>">` row is gated off by the shell's per-offer flag (decision 27), so the missing
 * token never shows.
 */
export function buildFeaturePurchaseInfoTokens(input: {
  featurePriceMultipliersById: Readonly<Record<string, number>>;
  featureModeMultipliersById: Readonly<Record<string, number>>;
}): Record<string, string> {
  const tokens: Record<string, string> = {};
  const addToken = (tokenName: string, multiplier: number | undefined): void => {
    if (typeof multiplier === "number" && multiplier > 0) tokens[tokenName] = String(multiplier);
  };
  addToken("feature.super_bonus_buy.multiplier", input.featurePriceMultipliersById["super_bonus_buy"]);
  addToken("feature.vs_rush_buy.multiplier", input.featurePriceMultipliersById["vs_rush_buy"]);
  addToken("feature.bonus_hunt.multiplier", input.featureModeMultipliersById["bonus_hunt_mode"]);
  addToken("feature.guaranteed_vs_mode.multiplier", input.featureModeMultipliersById["guaranteed_vs_mode"]);
  return tokens;
}
